export type DayOfWeek = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export type TimePeriod = 'AM' | 'PM';

export const EventRecordingMode = {
  ENABLED: 'enabled',
  SNAPSHOT_ONLY: 'snapshotOnly',
  DISABLED: 'disabled',
} as const;

export type EventRecordingModeType = (typeof EventRecordingMode)[keyof typeof EventRecordingMode];

export interface RecordingBlock {
  id: string;
  startTime: string; // "HH:MM" 24h format
  endTime: string;   // "HH:MM" 24h format
  continuousRecording: boolean;
  clipEventRecording: boolean;
  snapshot: boolean;
  daysOfWeek: DayOfWeek[];
}

export interface RecordingFormValues {
  blocks: RecordingBlock[];
}
